import {
  SiHtml5,
  SiCss3,
  SiJavascript,
  SiReact,
  SiNodedotjs,
  SiDocker,
  SiGit,
  SiStyledcomponents,
  SiMaterialui,
  SiRedux,
  SiTypescript,
  SiExpress,
  SiPostgresql,
  SiJest,
  SiPython,
  SiDjango,
  SiNextdotjs,
} from "react-icons/si";

const skills = [
  {
    id: 0,
    skillName: "HTML",
    img: SiHtml5,
  },
  {
    id: 1,
    skillName: "CSS",
    img: SiCss3,
  },
  {
    id: 2,
    skillName: "JavaScript",
    img: SiJavascript,
  },
  { id: 3, skillName: "React.js", img: SiReact },
  {
    id: 4,
    skillName: "Next.js",
    img: SiNextdotjs,
  },
  {
    id: 5,
    skillName: "Redux",
    img: SiRedux,
  },
  {
    id: 6,
    skillName: "Material UI",
    img: SiMaterialui,
  },
  {
    id: 7,
    skillName: "Styled Components",
    img: SiStyledcomponents,
  },
  {
    id: 8,
    skillName: "TypeScript",
    img: SiTypescript,
  },
  {
    id: 9,
    skillName: "Node.js",
    img: SiNodedotjs,
  },
  {
    id: 10,
    skillName: "Express",
    img: SiExpress,
  },
  {
    id: 11,
    skillName: "PostgreSQL",
    img: SiPostgresql,
  },
  {
    id: 12,
    skillName: "Jest",
    img: SiJest,
  },
  {
    id: 13,
    skillName: "Python",
    img: SiPython,
  },
  {
    id: 14,
    skillName: "Django",
    img: SiDjango,
  },
  {
    id: 15,
    skillName: "Docker",
    img: SiDocker,
  },
  {
    id: 16,
    skillName: "Git and GitHub",
    img: SiGit,
  },
];

export default skills;
